import { useEffect, useState, useMemo } from 'react';
import { useAppSelector, ApplicationStatus, IApplication } from '../utils';

export const useIsUserAllowedForActions = (application: IApplication, index: number) => {
    const [isUserAllowed, setIsUserAllowed] = useState(false);

    const userPermissionList: string[] = useAppSelector(
        state => state.capApplications.capApplicationsInfo.userPermissionList,
    );
    const isInsideOE: boolean = useAppSelector(state => state.capApplications.capApplicationsInfo.insideOE);

    const checkPermissions = useMemo(() => {
        const hasPermission = (permission: string) => userPermissionList.includes(permission);

        const conditions = [
            hasPermission('IND_PORTAL_EDIT_SPCL_ENRLMNT_PERIOD'),
            hasPermission('MYAPP_CHANGE_COVRAGE_STARTDATE') &&
                application.applicationStatus !== ApplicationStatus.Closed &&
                index === 0,
            hasPermission('MYAPP_VIEW_OVERRIDE_HIST'),
            hasPermission('MYAPP_EDIT_NONFIN_APP') &&
                [
                    ApplicationStatus.EligibilityReceived,
                    ApplicationStatus.PartiallyEnrolled,
                    ApplicationStatus.EnrolledOrActive,
                    ApplicationStatus.Signed,
                ].includes(application.applicationStatus as ApplicationStatus),
            hasPermission('MYAPP_INIT_NONFIN_VERIFICATION') && application.isNonFinancial,
            hasPermission('MYAPP_RTN_NONFIN_ELIGIBILITY') && application.isNonFinancial,
            hasPermission('MYAPP_CANCEL_TERMPLAN') &&
                [ApplicationStatus.PartiallyEnrolled, ApplicationStatus.EnrolledOrActive].includes(
                    application.applicationStatus as ApplicationStatus,
                ),
            hasPermission('MYAPP_SEND_DEMOGRPHCUPDT_CARRIER'),
            hasPermission('MYAPP_OVERRD_SPCL_ENROLLMENT') &&
                !isInsideOE &&
                application.applicationStatus === ApplicationStatus.EligibilityReceived &&
                (application.isQep || application.isSepApp) &&
                !(application.eligibilityStatus === 'DE' && application.isNonFinancial),
            hasPermission('MYAPP_OVERRD_APTCELGBLT_STARTDT') &&
                application.isSepApp &&
                application.applicationStatus === ApplicationStatus.EligibilityReceived &&
                !application.isNonFinancial,
            hasPermission('MYAPP_OPEN_PLAN_SHOPPING_WINDOW') &&
                index === 0 &&
                application.isExchangeEligible &&
                application.isLatestApplication,
            hasPermission('MYAPP_OVERRIDE_PROG_ELIG') &&
                [
                    ApplicationStatus.EligibilityReceived,
                    ApplicationStatus.PartiallyEnrolled,
                    ApplicationStatus.EnrolledOrActive,
                ].includes(application.applicationStatus as ApplicationStatus),
        ];

        return conditions.some(condition => condition);
    }, [application, userPermissionList, index, isInsideOE]);

    useEffect(() => {
        setIsUserAllowed(checkPermissions);
    }, [checkPermissions]);

    return isUserAllowed;
};
